import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'LinkedIn',
      href: 'https://linkedin.com/company/civioniks',
      icon: (
        <svg className="w-4 h-4 xs:w-5 xs:h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      ),
    },
    {
      name: 'Twitter',
      href: 'https://twitter.com/civioniks',
      icon: (
        <svg className="w-4 h-4 xs:w-5 xs:h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
        </svg>
      ),
    },
    {
      name: 'GitHub',
      href: 'https://github.com/civioniks',
      icon: (
        <svg className="w-4 h-4 xs:w-5 xs:h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
        </svg>
      ),
    },
  ];

  const quickLinks = [
    { name: 'Features', href: '#features' },
    { name: 'How It Works', href: '#how-it-works' },
    { name: 'About', href: '#about' },
    { name: 'API Access', href: '#api-access' },
  ];


  const legal = [
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Terms of Service', href: '/terms-of-service' },
    { name: 'Security', href: '/security' },
    { name: 'Compliance', href: '/compliance' },
  ];

  const scrollToSection = (sectionId) => {
    // Check if we're on a legal page
    const isLegalPage = window.location.pathname !== '/';
    
    if (isLegalPage) {
      // On legal pages, navigate to main website with section
      window.location.href = `/#${sectionId.replace('#', '')}`;
    } else {
      // On main website, scroll to section
      const element = document.getElementById(sectionId.replace('#', ''));
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  };

  return (
    <footer id="contact" className="bg-[#0A1016] text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-48 h-48 xs:w-96 xs:h-96 bg-primary-900/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-48 h-48 xs:w-96 xs:h-96 bg-accent-900/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative">
        {/* Main footer content */}
        <div className="py-6 px-4 xs:py-8 xs:px-6 sm:py-12 sm:px-6 lg:py-16 lg:px-8">
          <div className="container-mobile">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 xs:gap-8 lg:gap-16">
              {/* Brand section */}
              <div className="lg:col-span-2">
                <div className="mb-4 xs:mb-6">
                  <div className="mb-2 xs:mb-3 relative flex justify-center">
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 xs:w-80 xs:h-80 sm:w-96 sm:h-96 bg-gradient-to-br from-white/20 via-white/30 to-white/20 rounded-full blur-2xl"></div>
                    <img 
                      src="/logo with words.png" 
                      alt="CIVIONIKS" 
                      className="h-40 xs:h-48 sm:h-56 lg:h-64 w-auto relative z-10"
                    />
                  </div>
                  <p className="text-gray-300 text-sm xs:text-base sm:text-lg leading-relaxed max-w-md mx-auto text-center lg:text-left">
                    Transforming infrastructure monitoring with AI-driven insights and real-time analytics for critical infrastructure management.
                  </p>
                </div>

                {/* Contact info */}
                <div className="space-y-2 xs:space-y-3 mb-4 xs:mb-6">
                  <div className="flex items-center text-gray-300 justify-center lg:justify-start">
                    <svg className="w-4 h-4 xs:w-5 xs:h-5 mr-2 xs:mr-3 text-primary-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <a href="mailto:hello@civioniks.com" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm xs:text-base">
                      hello@civioniks.com
                    </a>
                  </div>
                  <div className="flex items-center text-gray-300 justify-center lg:justify-start">
                    <svg className="w-4 h-4 xs:w-5 xs:h-5 mr-2 xs:mr-3 text-primary-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    <a href="tel:+16476926922" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm xs:text-base">
                      +1 (647) 692-6922
                    </a>
                  </div>
                </div>

                {/* Social links */}
                <div className="text-center lg:text-left">
                  <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-2 xs:mb-3">
                    Follow Us
                  </h4>
                  <div className="flex space-x-2 xs:space-x-3 justify-center lg:justify-start">
                    {socialLinks.map((link) => (
                      <a
                        key={link.name}
                        href={link.href}
                        className="group p-2 xs:p-3 bg-gray-800 rounded-lg hover:bg-primary-600 transition-all duration-300 transform hover:-translate-y-1 touch-target min-w-[40px] min-h-[40px] xs:min-w-[48px] xs:min-h-[48px] flex items-center justify-center"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Follow us on ${link.name}`}
                      >
                        <div className="text-gray-400 group-hover:text-white transition-colors duration-300">
                          {link.icon}
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              </div>

              {/* Navigation sections */}
              <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-4 xs:gap-6 lg:gap-8">
                {/* Quick Links */}
                <div className="text-center sm:text-left">
                  <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-3 xs:mb-4">
                    Quick Links
                  </h4>
                   <ul className="space-y-2 xs:space-y-3">
                     {quickLinks.map((link) => (
                       <li key={link.name}>
                         <button
                           onClick={() => scrollToSection(link.href)}
                           className="text-gray-300 hover:text-white transition-colors duration-200 text-center sm:text-left block text-sm xs:text-base w-full py-1 px-0 bg-transparent border-0 cursor-pointer text-left"
                         >
                           {link.name}
                         </button>
                       </li>
                     ))}
                   </ul>
                </div>

                {/* Legal */}
                <div className="text-center sm:text-left">
                  <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-3 xs:mb-4">
                    Legal
                  </h4>
                   <ul className="space-y-2 xs:space-y-3">
                     {legal.map((link) => (
                       <li key={link.name}>
                         <a
                           href={link.href}
                           className="text-gray-300 hover:text-white transition-colors duration-200 text-sm xs:text-base block text-center sm:text-left w-full py-1 px-0 text-left"
                         >
                           {link.name}
                         </a>
                       </li>
                     ))}
                   </ul>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* Bottom section */}
        <div className="border-t border-gray-800">
          <div className="py-4 xs:py-6 sm:py-8">
            <div className="container-mobile">
              <div className="flex flex-col gap-3 xs:gap-4 sm:gap-6 md:flex-row md:justify-between md:items-center text-center md:text-left">
                <div className="text-gray-400 order-2 md:order-1">
                  <p className="text-xs xs:text-sm sm:text-base">&copy; {currentYear} CIVIONIKS. All rights reserved.</p>
                </div>
                
                <div className="flex flex-col gap-2 xs:gap-3 sm:flex-row sm:gap-4 items-center justify-center md:justify-end text-xs xs:text-sm order-1 md:order-2">
                  <div className="flex items-center text-gray-400">
                    <div className="w-1.5 h-1.5 xs:w-2 xs:h-2 bg-green-500 rounded-full mr-1.5 xs:mr-2 animate-pulse"></div>
                    <span>All systems operational</span>
                  </div>
                  
                  <div className="flex items-center text-gray-400">
                    <svg className="w-3 h-3 xs:w-4 xs:h-4 mr-1.5 xs:mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span>SOC 2 Compliant</span>
                  </div>
                  
                  <button
                    onClick={() => scrollToSection('#hero')}
                    className="flex items-center text-gray-400 hover:text-white transition-colors duration-200 group touch-target"
                  >
                    <span>Back to Top</span>
                    <svg className="w-3 h-3 xs:w-4 xs:h-4 ml-1 group-hover:-translate-y-0.5 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 